import { AnalyticsEvent } from "../analytics_types.js";
import { AnalyticsTransport } from "./analytics_transport.js";

export enum ConsoleAnalyticsMethod
{
  LOG = 'log',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
}

export class ConsoleAnalyticsTransport implements AnalyticsTransport
{
  private readonly method: ConsoleAnalyticsMethod;
  private readonly out_fn: ( ...args: unknown[] ) => void;

  constructor( method: ConsoleAnalyticsMethod = ConsoleAnalyticsMethod.LOG )
  {
    this.method = method;
    const method_fn = console[this.method] as ( ( ...args: unknown[] ) => void ) | undefined;
    const base_fn = typeof method_fn === 'function' ? method_fn : console.log;
    this.out_fn = base_fn.bind( console );
  }

  async send( event: AnalyticsEvent ): Promise<void>
  {
    this.out_fn( '[ANALYTICS]', event.name, event );
  }
}
